import type { RelationshipFieldProps } from "../../types/skyward/treebrowse";
import { defineBaseFieldComponent } from "./baseField";
import * as Classes from "./classes";

export const RelationshipField = defineBaseFieldComponent<RelationshipFieldProps, ReturnType<typeof formatField>>(
    {
        name: "relationshipField",
        additionalRowAttributes(relationship) {
            const isOneToMany = relationship.relationshipType === "OneToMany";
            const attributes =
            {
                class: {
                    [Classes.treebrowserow]: true,
                    [Classes.jsOneToManyDraggable]: isOneToMany,
                }
            };
            return attributes;
        },
        nameCell: (relationship) =>
            <td>
                <span class=
                    {{
                        [Classes.selectable]: true,
                        [Classes.relationship]: true,
                        [Classes.treeBrowseSectionHeader]: true
                    }}
                >
                    {relationship.relationshipName}
                </span>
            </td>,
        typeIcon: (relationship) => relationship.svgClass,
        fieldKey: (relationship) => relationship.fieldPath,
        formatField,
    }
);

function formatField(field: RelationshipFieldProps)
{
    const result =
    {
        // These correspond to old data- attribute names, used in reporting and elsewhere
        fieldType: field.relationshipType,
        fieldName: field.fieldPath,
        fieldModule: field.moduleName,
        fieldObject: field.objectName,

        isOneToMany: field.relationshipType === "OneToMany",
        relationshipPath: field.fieldPath.substring(field.fieldPath.indexOf(".") + 1),

        // Used by treebrowse.ts
        isRelationship: true
    };
    return result;
}
